import * as React from 'react'

import { ExistingUser } from '../common'
import { ChooseContainer, StyledButton } from './ChooseRole.styles'

interface IProps {
  onRequestParentSignUp: () => void
  onRequestLogin: () => void
}

function ChooseRole(props: IProps) {
  const { onRequestLogin, onRequestParentSignUp } = props

  return (
    <>
      <a href="/join?type=director">
        <StyledButton kind="outline" full>
          Start a Wonderschool
        </StyledButton>
      </a>

      <StyledButton kind="outline" full onClick={() => onRequestParentSignUp()}>
        Find a Wonderschool
      </StyledButton>

      <ChooseContainer>
        <ExistingUser onRequestLogin={onRequestLogin} />
      </ChooseContainer>
    </>
  )
}

export default React.memo(ChooseRole)
